import React from 'react';

export const PipeSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.85107 0V21.3404C8.85107 22.9973 10.1942 24.3404 11.8511 24.3404H35.4043" stroke={color} strokeWidth="11" />
        <rect y="6.12891" width="16.8511" height="6.12766" rx="3.06383" fill={color} />
        <rect x="29.8726" y="32.1699" width="16.8511" height="6.12766" rx="3.06383" transform="rotate(-90 29.8726 32.1699)" fill={color} />
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.85107 0V21.3404C8.85107 22.9973 10.1942 24.3404 11.8511 24.3404H35.4043" stroke="#E41D1D" strokeWidth="11" />
      <rect y="6.12891" width="16.8511" height="6.12766" rx="3.06383" fill="#981313" />
      <rect x="29.8726" y="32.1699" width="16.8511" height="6.12766" rx="3.06383" transform="rotate(-90 29.8726 32.1699)" fill="#981313" />
    </svg>
  )
}